import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10303856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-upload" }
const _hoisted_2 = { class: "image-controls" }
const _hoisted_3 = { class: "image-upload" }

import Button from '@ui-kit/controls/button/Button.vue';
import { ref, watch } from 'vue';
import { useModalsStore } from '@/stores/modals';
import ModalImageCropper from './ModalImageCropper.vue';
import { FilesService } from '@/services/files.service';
import ImageCollectionPreview from '@ui-kit/image/ImageCollectionPreview.vue';

interface Props {
  modelValue: number[];
  ratio?: [number, number];
  multiple?: boolean;
  width?: number;
  disableRemove?: boolean;
}
interface Emits {
  (e: 'update:modelValue', images: number[]): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageUpload',
  props: {
    modelValue: null,
    ratio: { default: () => [1, 1] },
    multiple: { type: Boolean },
    width: { default: 200 },
    disableRemove: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', images: number[]): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number[], ratio: [number, number], multiple?: boolean, width: number, disableRemove?: boolean }

const MIME_EXT_MAP: Record<string, string> = {
  'image/png': '.png',
  'image/jpeg': '.jpg',
};





const fileService = new FilesService();
const modalsStore = useModalsStore();

const onUpload = ref<boolean>(false);
const onDeleting = ref<boolean>(false);
const inputFileRef = ref<HTMLElement>();
const currentImageIndex = ref<number>(0);

function onClickUpload() {
  const inputFile = inputFileRef.value;
  if (inputFile) {
    inputFile.click();
  }
}

function onFileInput(e: InputEvent) {
  const target = e.target as HTMLInputElement;
  const files = target.files;
  if (files && files[0]){
    const imageSrc = URL.createObjectURL(files[0]);
    target.value = '';
    modalsStore.addModal({
      component: ModalImageCropper,
      props: {
        imageSrc,
        ratio: props.ratio,
      },
      events: {
        async crop(blob: Blob) {
          const ext = MIME_EXT_MAP[blob.type];
          if (ext) {
            onUpload.value = true;
            const { data } = await fileService
                .upload(new File([blob], `file${ext}`))
                .send()
                .finally(() => {
                  onUpload.value = false;
                });

            emit('update:modelValue', props.multiple ? [...props.modelValue, data] : [data]);
          }
        }
      }
    });
  }
}

async function onClickDelete() {
  onDeleting.value = true;

  const index = currentImageIndex.value;
  const id = props.modelValue[index];
  await fileService
      .delete(id)
      .send()
      .finally(() => {
        onDeleting.value = false;
      });
  emit('update:modelValue', props.modelValue.filter((_, i) => i !== index));
}

function handleReorder(reorder: { from: number, to: number }) {
  const { from, to } = reorder;
  if (currentImageIndex.value === from) {
    currentImageIndex.value = to;
  } else if (currentImageIndex.value === to) {
    currentImageIndex.value = from;
  }

  let newIds = [...props.modelValue];
  const fromId = newIds[from];
  newIds[from] = newIds[to];
  newIds[to] = fromId;

  emit('update:modelValue', newIds);
}

watch(() => props.modelValue, (value) => {
  if (currentImageIndex.value > value.length - 1) {
    currentImageIndex.value = Math.max(0, value.length - 1);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "image-preview",
      style: _normalizeStyle({width: `${__props.width}px`})
    }, [
      _createVNode(ImageCollectionPreview, {
        class: "w-full",
        currentImageIndex: currentImageIndex.value,
        "onUpdate:currentImageIndex": _cache[0] || (_cache[0] = ($event: any) => ((currentImageIndex).value = $event)),
        ratio: __props.ratio,
        images: __props.modelValue,
        "enable-reorder": "",
        onReorder: handleReorder
      }, null, 8, ["currentImageIndex", "ratio", "images"])
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          accept: "image/png, image/jpeg, image/webp",
          type: "file",
          class: "hidden",
          ref_key: "inputFileRef",
          ref: inputFileRef,
          onInput: onFileInput
        }, null, 544),
        _createVNode(Button, {
          loading: onUpload.value,
          onClick: onClickUpload,
          class: "w-36"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FontAwesomeIcon, {
              icon: "cloud-upload-alt",
              class: "mr-1"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.image-upload.upload')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      (!__props.disableRemove && __props.modelValue.length > 0)
        ? (_openBlock(), _createBlock(Button, {
            key: 0,
            color: "danger",
            class: "w-36",
            loading: onDeleting.value,
            onClick: onClickDelete
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FontAwesomeIcon, {
                icon: "trash-alt",
                class: "mr-2"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.delete')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})